import React from 'react';
import { BaseFieldProps } from 'modules/form';

import styles from './MultiSwitch.module.scss';

export type MultiSwitchProps = BaseFieldProps & {
    value: string | number | null;
    onChange: (value: string | number) => void;
    options: { label: string; value: string | number }[];
    isNumber?: boolean;
    onToggle?: () => void;
    isDisabled?: boolean;
    fullWidth?: boolean;
    size?: 'small' | 'large';
};

export const MultiSwitch: React.FC<MultiSwitchProps> = ({
    options,
    onToggle,
    isNumber = false,
    value: fieldValue,
    onChange,
    isDisabled,
    fullWidth = false,
    size = 'large',
    ...props
}) => (
    <div className={styles['wrapper']} style={fullWidth ? { maxWidth: 'none', margin: 0 } : {}} {...props}>
        {options.map(({ label, value }, index) => {
            const buttonClassName = `${styles['button']} ${isDisabled ? styles['disabledBtn'] : ''}`;

            return (
                <button
                    disabled={isDisabled}
                    type="button"
                    className={buttonClassName}
                    role="radio"
                    value={value}
                    key={index}
                    onClick={() => {
                        if (isDisabled) return;
                        isNumber ? onChange(Number(value)) : onChange(value);
                        onToggle && onToggle();
                    }}
                    data-state={value == fieldValue ? 'on' : 'off'}
                    style={{
                        width: fullWidth ? '100%' : undefined,
                        textAlign: fullWidth ? 'center' : undefined,
                        paddingTop: size === 'small' ? '8px' : '11px',
                        paddingBottom: size === 'small' ? '8px' : '11px',
                    }}
                    {...props}
                >
                    {label}
                </button>
            );
        })}
    </div>
);
